import { ItemListContentBuilder } from "@eusoft/webapp-framework/content/ItemListContent"
import { Authorize } from "../services/Authorize"
import { userSession } from "../services/UserSession"
import type { ResourceName } from "../entities/Types"

declare module "@eusoft/webapp-framework" {

    interface ItemListContentBuilder<TItem, TFilter> {
        resource(res: ResourceName) : this
    }
}

ItemListContentBuilder.prototype.resource = function (this: ItemListContentBuilder<{ id: string }, unknown>, res: ResourceName) {

    this.options({
        canAdd: () => userSession.hasPermission(res, "create"),
        canDelete: item => userSession.hasPermission(res, "delete", item?.id),
        canEdit: item => userSession.hasPermission(res, "edit", item?.id)
    })

    this.feature(Authorize(a => a
        .resource(res, "list")));

    return this;
}